import { RangeType } from '@nemuru-eng/js-api-client';

import { RangesEditorTextValues } from '../types/rangesEditorTexts';

export const RANGES_EDITOR_TEXT_VALUES: RangesEditorTextValues = {
  [RangeType.PERIOD]: {
    minGreaterThanMaxError: 'MIN_PERIOD_CANNOT_BE_GREATER_THAN_MAX_PERIOD',
    minLowerThanMinAllowedError: 'MIN_PERIOD_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PERIOD',
    maxGreaterThanMaxAllowedError: 'MAX_PERIOD_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PERIOD',
    min: 'MIN_PERIOD',
    max: 'MAX_PERIOD',
  },
  [RangeType.PRINCIPAL]: {
    minGreaterThanMaxError: 'MIN_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_PRINCIPAL',
    minLowerThanMinAllowedError: 'MIN_PRINCIPAL_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PRINCIPAL',
    maxGreaterThanMaxAllowedError: 'MAX_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PRINCIPAL',
    min: 'MIN_PRINCIPAL',
    max: 'MAX_PRINCIPAL',
  },
};
